export const ADD_PRODUCT_CART_REQUEST = "ADD_PRODUCT_CART_REQUEST"
export const ADD_PRODUCT_CART_SUCCESS = "ADD_PRODUCT_CART_SUCCESS"
export const ADD_PRODUCT_CART_FAILURE = "ADD_PRODUCT_CART_FAILURE"

export const FETCH_CART_REQUEST = "FETCH_CART_REQUEST"
export const FETCH_CART_SUCCESS = "FETCH_CART_SUCCESS"
export const FETCH_CART_FAILURE = "FETCH_CART_FAILURE"

export const REMOVE_CART_REQUEST = "REMOVE_CART_REQUEST"
export const REMOVE_CART_SUCCESS = "REMOVE_CART_SUCCESS"
export const REMOVE_CART_FAILURE = "REMOVE_CART_FAILURE"

export const PATCH_CART_REQUEST = "PATCH_CART_REQUEST"
export const PATCH_CART_SUCCESS = "PATCH_CART_SUCCESS"
export const PATCH_CART_FAILURE = "PATCH_CART_FAILURE"
